<template>
  <div class="search-content">
    <el-row class="ListMenu">
      <el-col>
        <el-form
          ref="form"
          :model="listMenuForm"
          class="searchForm orderSelect"
        >
          <el-form-item class="searchItem">
            <el-select v-model="orderChoice" @change="handleSelectChange">
              <el-option label="售後編號" value="afterSalesNo"></el-option>
              <el-option label="訂單編號" value="orderNum"></el-option>
              <el-option label="用戶賬號" value="email"></el-option>
              <el-option label="貨運單號" value="trackingNumber"></el-option>
              <el-option label="姓名" value="name"></el-option>
              <el-option label="手機" value="mobile"></el-option>
            </el-select>
            <el-input
              style="marginLeft:5px"
              placeholder="在左側選擇搜索類別"
              v-model="listMenuForm[orderChoice]"
              @change="handleInputChange(orderChoice)"
            >
            </el-input>
          </el-form-item>
          <div class="leftwidth"></div>
          <el-form-item label="開始時間" class="searchItem">
            <el-date-picker
              v-model="listMenuForm.startTime"
              type="datetime"
              placeholder="選擇時間"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="結束時間" class="searchItem">
            <el-date-picker
              v-model="listMenuForm.endTime"
              type="datetime"
              placeholder="選擇時間"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="" style="width: 60px;">
            <p
              class="recentlyTitle"
              style="display: inline-block;"
              @click="choiceTime()"
            >
              最近31天
            </p>
          </el-form-item>
          <el-form-item label="售後狀態">
            <el-select
              style="width: 160px !important;"
              v-model="listMenuForm.subType"
              @change="handleSelectChange"
              placeholder="请選擇售後狀態"
            >
              <el-option
                v-for="item in subTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="收件地區" class="searchItem">
            <el-select v-model="listMenuForm.area" @change="handleSelectChange">
              <el-option label="大陸" :value="1"></el-option>
              <el-option label="港澳臺新馬" :value="2"></el-option>
              <el-option label="其他地區" :value="3"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <div class="MenuBtnWrap_right">
      <div class="btn" style="margin-right: 20px;" @click="uoloadModal = true">
        <!-- <el-upload
          class="colorfades"
          name="file"
          ref="excelUpload"
          :action="this.$GLOBAL.allorderExcelPostUrl"
          :headers="{ Authorization: this.$cookie.get('auth') }"
          :with-credentials="true"
          :before-upload="beforeExcelUpload"
          :on-remove="handleRemove"
          :on-success="successExcel"
          :on-error="errorExcel"
          :show-file-list="false"
          :multiple="false"
          :file-list="fileList"
          :on-change="fileChange"
          :on-exceed="handleExceed"
          :limit="1"
        >
          <span style="color: #ffffff;">批量發貨</span>
        </el-upload> -->
        <span style="color: #ffffff;">批量發貨</span>
      </div>
      <div class="btn" @click="search()" style="marginRight:0.2rem">查詢</div>
      <div class="btn borderBtn" @click="reset()">重置</div>
    </div>
    <div class="tableWrap" style="marginTop:30px">
      <el-table height="660px" stripe :data="orderList" style="width:100%;">
        <template slot="empty">
          <div class="no-data-container">
            <img
              src="@/assets/images/common/no_data.png"
              alt="暂无数据"
              :style="{ width: '244px', height: '139px' }"
            />
          </div>
        </template>
        <el-table-column type="index" label="#" width="50"> </el-table-column>
        <el-table-column
          v-for="(item, index) in orderListTable"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
        >
          <template slot-scope="scope">
            <div v-if="!scope.row[item.prop] && scope.row[item.prop] !== 0">
              -
            </div>
            <div v-else-if="item.prop == 'status'">
              {{ changeStatus(scope.row.status) }}
            </div>
            <div v-else-if="item.prop == 'orderStatus'">
              {{ changeOrderStatus(scope.row.orderStatus) }}
            </div>
            <div v-else-if="item.prop == 'shopList'">
              <div v-for="(item, index) in scope.row.shopList" :key="index">
                {{ item.num }}x{{ item.goodsName }}
              </div>
            </div>
            <div v-else-if="item.prop == 'price'">
              {{ scope.row.price }}{{ scope.row.currency }}
            </div>
            <div
              v-else-if="item.prop === 'orderNum'"
              :style="{ color: '#6C3DEA', cursor: 'pointer' }"
              @click="
                $router.push(
                  '/orderDetails?orderNum=' +
                    scope.row.orderNum +
                    '&id=' +
                    scope.row.id
                )
              "
            >
              {{ scope.row[item.prop] }}
            </div>
            <div v-else-if="item.prop === 'name'">
              <div>{{ scope.row.name }}</div>
              <div
                :style="{ color: '#6C3DEA', cursor: 'pointer' }"
                @click="
                  $router.push(
                    '/userDetails?id=' + scope.row.userId + '&status=all'
                  )
                "
              >
                {{ scope.row.email }}
              </div>
            </div>
            <div v-else>{{ scope.row[item.prop] }}</div>
          </template>
        </el-table-column>
        <el-table-column type="index" label="操作" width="100">
          <template slot-scope="scope">
            <div
              style="color:#6c3dea;cursor: pointer;"
              @click="
                $router.push(
                  '/afterSalesDetails?orderNum=' +
                    scope.row.orderNum +
                    '&id=' +
                    scope.row.id
                )
              "
            >
              查看詳情
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="paging-block clearfix">
      <el-pagination
        class="paging fr"
        hide-on-single-page
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        @size-change="handleSizeChange"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="currentPageSize"
        :pager-count="5"
        layout="sizes, prev, pager, next, jumper "
        :total="total"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="提示信息"
      :visible.sync="uoloadModal"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="500px"
      center
      @close="cancelYunfei"
    >
      <div class="dialog">
        <div>
          <div style="display: flex;">
            <div>
              上傳發貨單：
            </div>
            <el-upload
              ref="excelUpload"
              :action="this.$GLOBAL.allorderExcelPostUrl"
              :with-credentials="true"
              class="upload-demo"
              :headers="{ Authorization: this.$cookie.get('auth') }"
              drag
              :accept="'.xlsx,.xls'"
              :multiple="false"
              :file-list="fileList"
              :on-change="fileChange"
              :on-success="successExcel"
              :on-error="errorExcel"
              :auto-upload="false"
              :limit="1"
            >
              <img
                src="@/assets/images/common/blacklist_upload.png"
                alt="暂无数据"
                :style="{
                  width: '41px',
                  height: '41px',
                  marginTop: '40px',
                  marginBottom: '14px'
                }"
              />
              <div class="el-upload__text">
                上傳模板
              </div>
            </el-upload>
            <div
              style="
              color: #9d58ff;
              cursor: pointer;"
              @click="downExcel"
            >
              下載模板
            </div>
          </div>
          <div class="btngroup">
            <div
              class="btn borderBtn"
              style="marginRight:112px"
              @click="cancelYunfei"
            >
              取消
            </div>
            <div class="btn" @click="submitupdate">發貨</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import DiaMess from "@/components/dialog";
export default {
  props: ["orderStatus"],
  data() {
    return {
      listMenuForm: {
        orderNum: "",
        afterSalesNo: "",
        trackingNumber: "",
        name: "",
        mobile: "",
        startTime: "",
        endTime: "",
        orderType: "",
        email: "",
        area: 1,
        subType: ""
      },
      orderChoice: "afterSalesNo",
      tags: [],
      orderList: [],
      orderListTable: [
        {
          prop: "status",
          label: "售後狀態",
          minWidth: "100"
        },
        {
          prop: "createTime",
          label: "申請售後時間",
          minWidth: "170"
        },
        {
          prop: "afterSalesNo",
          label: "售後編號",
          minWidth: "190"
        },
        {
          prop: "orderNum",
          label: "訂單編號",
          minWidth: "170"
        },
        {
          prop: "name",
          label: "訂購人",
          minWidth: "190"
        },
        {
          prop: "address",
          label: "收件地區",
          minWidth: "100"
        },
        {
          prop: "shopList",
          label: "售後品項",
          minWidth: "130"
        },
        {
          prop: "price",
          label: "訂單金額",
          minWidth: "200"
        },
        {
          prop: "orderStatus",
          label: "訂單狀態",
          minWidth: "200"
        },
        {
          prop: "updateTime",
          label: "更新時間",
          minWidth: "200"
        }
      ],
      currentPage: 1,
      currentPageSize: 20,
      total: 10,
      dialogVisible: false,
      fileList: [],
      subTypeOptions: [],
      uoloadModal: false
    };
  },
  created() {
    if (this.orderStatus === "0") {
      this.subTypeOptions = [
        {
          value: 1,
          label: "待審核"
        },
        {
          value: 2,
          label: "已取消"
        },
        {
          value: 3,
          label: "審核通過"
        },
        {
          value: 4,
          label: "審核不通過"
        },
        {
          value: 5,
          label: "補充資料"
        },
        {
          value: 6,
          label: "處理中"
        },
        {
          value: 7,
          label: "換貨異常"
        },
        {
          value: 8,
          label: "已出貨"
        },
        {
          value: 9,
          label: "已完成"
        },
        {
          value: 10,
          label: "已關閉"
        }
      ];
    } else if (this.orderStatus === "1") {
      this.subTypeOptions = [
        {
          value: 1,
          label: "待審核"
        },
        {
          value: 5,
          label: "補充資料"
        }
      ];
    } else if (this.orderStatus === "2") {
      this.subTypeOptions = [
        {
          value: 3,
          label: "審核通過"
        },
        {
          value: 6,
          label: "處理中"
        },
        {
          value: 7,
          label: "換貨異常"
        }
      ];
    } else if (this.orderStatus === "3") {
      this.subTypeOptions = [
        {
          value: 2,
          label: "已取消"
        },
        {
          value: 4,
          label: "審核不通過"
        },
        {
          value: 8,
          label: "已出貨"
        },
        {
          value: 9,
          label: "已完成"
        },
        {
          value: 10,
          label: "已關閉"
        }
      ];
    }
    this.getOrderList();
  },
  activated() {
    this.getOrderList();
  },
  beforeDestroy() {
    console.log("全部销毁", this.orderStatus);
  },
  methods: {
    getOrderList() {
      let _this = this;
      let startTime, endTime;
      if (
        _this.listMenuForm.startTime === "" ||
        _this.listMenuForm.startTime === null
      ) {
        startTime = null;
      } else {
        startTime = _this.$formatDate(_this.listMenuForm.startTime);
      }
      if (
        _this.listMenuForm.endTime === "" ||
        _this.listMenuForm.endTime === null
      ) {
        endTime = null;
      } else {
        endTime = _this.$formatDate(_this.listMenuForm.endTime);
      }
      let param = {
        afterSalesNo:
          _this.listMenuForm.afterSalesNo === ""
            ? null
            : _this.listMenuForm.afterSalesNo,
        orderNum:
          _this.listMenuForm.orderNum === ""
            ? null
            : _this.listMenuForm.orderNum,
        status: _this.orderStatus === "" ? null : _this.orderStatus,
        name: _this.listMenuForm.name === "" ? null : _this.listMenuForm.name,
        mobile:
          _this.listMenuForm.mobile === "" ? null : _this.listMenuForm.mobile,
        trackingNumber:
          _this.listMenuForm.trackingNumber === ""
            ? null
            : _this.listMenuForm.trackingNumber,
        startTime: startTime,
        endTime: endTime,
        area: _this.listMenuForm.area,
        email:
          _this.listMenuForm.email === "" ? null : _this.listMenuForm.email,
        pageNo: _this.currentPage,
        pageSize: _this.currentPageSize,
        subType: _this.listMenuForm.subType
      };
      _this
        .$post("/request/after/sales/list", param, _this.$GLOBAL.jsonConfig)
        .then(res => {
          if (res.code === "00000") {
            _this.total = res.data.allRow;
            res.data.list.forEach(v => {
              v.createTime = _this.$getTime(v.createTime);
              v.updateTime = _this.$getTime(v.updateTime);
            });
            _this.orderList = res.data.list;
          } else {
            _this.dialogVisible = true;
            _this.$propMessage(res.message, "error", function() {
              _this.dialogVisible = false;
            });
          }
        });
    },
    submitupdate() {
      this.$refs.excelUpload.submit();
    },
    cancelYunfei() {
      this.uoloadModal = false;
      this.$refs.excelUpload.clearFiles();
    },
    changeStatus(val) {
      switch (val) {
        case 1:
          return "待審核";
          break;
        case 2:
          return "已取消";
          break;
        case 3:
          return "審核通過";
          break;
        case 4:
          return "審核不通過";
          break;
        case 5:
          return "補充資料";
          break;
        case 6:
          return "處理中";
          break;
        case 7:
          return "換貨異常";
          break;
        case 8:
          return "已出貨";
          break;
        case 9:
          return "已完成";
          break;
        case 10:
          return "已關閉";
          break;
      }
    },
    changeOrderStatus(val) {
      switch (val) {
        case 1:
          return "未付款";
        case 2:
          return "已付款";
        case 3:
          return "付款失敗";
        case 4:
          return "已過期";
        case 5:
          return "已發貨";
        case 6:
          return "已收貨";
        case 7:
          return "待審核";
        case 8:
          return "訂單取消";
        case 9:
          return "審核失敗";
        case 10:
          return "退件";
        case 11:
          return "待發貨";
        case 12:
          return "支付確認中";
      }
    },
    handleInputChange(e) {
      this.listMenuForm.trackingNumber = this.listMenuForm.trackingNumber.replace(
        /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/g,
        ""
      );
      this.listMenuForm.afterSalesNo = this.listMenuForm.afterSalesNo.replace(
        /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/g,
        ""
      );
      this.listMenuForm.orderNum = this.listMenuForm.orderNum.replace(
        /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/g,
        ""
      );
    },
    handleSelectChange() {
      this.listMenuForm.orderNum = "";
      this.listMenuForm.afterSalesNo = "";
      this.listMenuForm.trackingNumber = "";
      this.listMenuForm.name = "";
      this.listMenuForm.mobile = "";
      this.listMenuForm.orderType = "";
      this.listMenuForm.email = "";
    },
    downExcel() {
      window.open(
        "https://start.sanctuarytech.co/resource/excel/after_sales_delivery.xlsx"
      );
    },
    //关闭搜索条件框
    closeTag(e) {
      this.tags.splice(this.tags.indexOf(e), 1);
      if (e.key === "startTime") {
        this.listMenuForm.startTime = "";
        this.listMenuForm.endTime = "";
      } else {
        this.listMenuForm[e.key] = "";
      }
      this.getOrderList();
    },
    //新增搜索条件框
    tagAdd() {
      let _this = this;
      _this.tags = [];
      let obj = _this.listMenuForm;
      for (let key in obj) {
        if (obj[key] && key !== "orderType") {
          if (key === "orderNum") {
            this.tags.push({
              key,
              name: `订单编号：${obj[key]}`
            });
          } else if (key === "afterSalesNo") {
            this.tags.push({
              key,
              name: `会员帐号：${obj[key]}`
            });
          } else if (key === "trackingNumber") {
            this.tags.push({
              key,
              name: `货运单号：${obj[key]}`
            });
          } else if (key === "name") {
            this.tags.push({
              key,
              name: `姓名：${obj[key]}`
            });
          } else if (key === "mobile") {
            this.tags.push({
              key,
              name: `手机：${obj[key]}`
            });
          } else if (key === "startTime") {
            this.tags.push({
              key,
              name: `${_this.$formatDate(
                _this.listMenuForm.startTime
              )}-${_this.$formatDate(_this.listMenuForm.endTime)}`
            });
          } else if (key === "email") {
            this.tags.push({
              key,
              name: `平臺交易編號${obj[key]}`
            });
          }
        } else if (key === "orderType") {
          if (obj[key] === undefined) return;
          let orderTypeName;
          if (obj[key] === "4") {
            orderTypeName = "商城";
          } else if (obj[key] === "5") {
            orderTypeName = "扭蛋";
          } else if (obj[key] === "1") {
            orderTypeName = "VIP会籍";
          } else if (obj[key] === "2") {
            orderTypeName = "活動";
          } else {
            orderTypeName = "所有商品";
          }
          this.tags.push({
            key,
            name: orderTypeName
          });
        }
      }
    },
    // 搜索
    search() {
      //执行搜索校验逻辑
      let _this = this;
      if (
        _this.listMenuForm.name === "" &&
        _this.listMenuForm.mobile === "" &&
        _this.listMenuForm.afterSalesNo === "" &&
        _this.listMenuForm.orderNum === "" &&
        _this.listMenuForm.trackingNumber === "" &&
        _this.listMenuForm.startTime === "" &&
        _this.listMenuForm.endTime === "" &&
        _this.listMenuForm.email === "" &&
        _this.listMenuForm.orderType === undefined
      ) {
        _this.dialogVisible = true;
        _this.$propMessage("請輸入至少一個搜索條件", "error", function() {
          _this.dialogVisible = false;
        });

        return false;
      }
      if (
        _this.$compareTime(
          _this.listMenuForm.startTime,
          _this.listMenuForm.endTime
        )
      ) {
        _this.dialogVisible = true;
        _this.$propMessage("開始時間不可以晚於結束時間", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }

      if (_this.$compareTime(_this.listMenuForm.startTime, new Date())) {
        _this.dialogVisible = true;
        _this.$propMessage("開始時間不可以是未來時間", "error", function() {
          _this.dialogVisible = false;
        });

        return false;
      }

      if (_this.$compareTime(_this.listMenuForm.endTime, new Date())) {
        _this.dialogVisible = true;
        _this.$propMessage("結束時間不可以是未來時間", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }

      if (
        (_this.listMenuForm.startTime === "" &&
          _this.listMenuForm.endTime !== "") ||
        (_this.listMenuForm.startTime !== "" &&
          _this.listMenuForm.endTime === "")
      ) {
        _this.dialogVisible = true;
        _this.$propMessage("請同時選擇開始時間和結束時間", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }
      _this.$message.closeAll();
      _this.currentPage = 1;
      _this.tagAdd();
      console.log("<><>", this.listMenuForm);
      _this.getOrderList();
    },
    // 重置
    reset() {
      let _this = this;
      _this.listMenuForm = {
        orderNum: "",
        afterSalesNo: "",
        trackingNumber: "",
        name: "",
        mobile: "",
        startTime: "",
        endTime: "",
        orderType: "",
        email: "",
        area: 1,
        subType: ""
      };
      _this.currentPage = 1;
      this.tags = [];
      this.orderChoice = "afterSalesNo";
      _this.getOrderList();
    },
    // 分页
    handleCurrentChange(val) {
      let _this = this;
      _this.currentPage = val;
      _this.getOrderList();
    },
    handleSizeChange(val) {
      let _this = this;
      _this.currentPageSize = val;
      _this.getOrderList();
    },
    // 最近31天
    choiceTime() {
      let _this = this;
      var endTime = new Date();
      var startTime = new Date();
      startTime = startTime.getTime() - 3600 * 1000 * 24 * 31;
      _this.listMenuForm.startTime = new Date(startTime);
      _this.listMenuForm.endTime = endTime;
    },
    //上传
    beforeExcelUpload(file) {
      let _this = this;
      let result = _this.$checkData(file.name);
      if (file === "" && result === false) {
        _this.dialogVisible = true;
        _this.$propMessage("請選擇需要導入的Excel文件！", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }
    },
    // 上传excel超过限制回调函数
    handleExceed() {
      this.dialogVisible = true;
      this.$propMessage("最多上傳1個文件！", "error", function() {
        this.dialogVisible = false;
      });
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    // excel上传成功
    successExcel(res, file, fileList) {
      let _this = this;
      this.showMoadl = false;
      if (res.code === "00000") {
        _this.dialogVisible = true;
        _this.$propMessage("上傳成功", "success", function() {
          _this.dialogVisible = false;
          _this.getOrderList();
        });
        _this.$refs.excelUpload.clearFiles();
      } else {
        _this.dialogVisible = true;

        _this.$propMessage(res.data, "error", function() {
          _this.dialogVisible = false;
        });
        _this.$refs.excelUpload.clearFiles();
      }
    },
    // excel上传失败
    errorExcel(err, file, fileList) {
      let _this = this;
      _this.$refs.excelUpload.clearFiles();
      _this.dialogVisible = true;
      _this.$propMessage(err.message + ",請重新上傳", "error", function() {
        _this.dialogVisible = false;
      });
    },
    fileChange(file, fileList) {
      this.fileList = fileList;
    }
  },
  components: {
    DiaMess
  },
  watch: {
    orderStatus(val) {
      console.log("val", val);
    }
  }
};
</script>

<style lang="less" scoped>
.search-content {
  width: 100%;
  .ListMenu {
    display: flex;
  }
  .MenuBtnWrap {
    justify-content: flex-start;
    margin-top: 30px;
    .MenuBtnWrap_left {
      width: 100%;
      color: #292929;
      display: flex;
      align-items: center;
      overflow: auto;
      span:first-child {
        flex-shrink: 0;
      }

      .tags {
        width: 94%;
        overflow: auto;
        white-space: nowrap;
        display: flex;
        justify-content: flex-start;
      }
    }
  }
  .MenuBtnWrap_right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
@media screen and (min-width: 769px) {
  .ListMenu {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .searchForm {
      flex: 1;
      display: flex;
      justify-content: flex-start;

      .searchItem {
        margin-right: 0.3rem;
        margin-bottom: 0.2rem;
      }
    }

    .MenuBtnWrap {
      flex: 1;
    }
  }
}
@media screen and (max-width: 769px) {
  .MenuBtnWrap_right {
    margin-top: 0px;
  }
}

.btngroup {
  margin-top: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn {
  text-align: center;
}
.dialog {
  display: flex;
  justify-content: center;
}
/deep/.el-upload-dragger {
  width: 300px;
  margin: 0 15px;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/allOrder/afterItems.vue